"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideAjaxLoader = exports.showAjaxLoader = exports.hideLoader = exports.showLoader = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    isVisible: false,
    isAjaxLoading: false
};
const preloaderSlice = toolkit_1.createSlice({
    name: 'preloader',
    initialState: initialState,
    reducers: {
        showLoader: (state) => {
            state.isVisible = true;
            document.body.style.overflowY = 'hidden';
            document.body.scrollTop = 0;
            return state;
        },
        hideLoader: (state) => {
            state.isVisible = false;
            document.body.style.overflowY = 'scroll';
            return state;
        },
        showAjaxLoader: (state) => {
            state.isAjaxLoading = true;
            return state;
        },
        hideAjaxLoader: (state) => {
            state.isAjaxLoading = false;
            return state;
        }
    }
});
_a = preloaderSlice.actions, exports.showLoader = _a.showLoader, exports.hideLoader = _a.hideLoader, exports.showAjaxLoader = _a.showAjaxLoader, exports.hideAjaxLoader = _a.hideAjaxLoader;
exports.default = preloaderSlice.reducer;
